<template>
  <div class="previousBtn text-left" @click="goToPreviousPage()">
    <el-button
      type="text"
      icon="el-icon-arrow-left"
      class="button my-account-btn"
      v-bind:style="{ color: '#a31c25' }"
    >
      {{ previousPageBtnLabel }}
    </el-button>
  </div>
</template>

<script>
export default {
  props: {
    labelCode: {
      type: String,
      default: "label",
    },
    linkTo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      colneLink: this.linkTo,
    };
  },
  computed: {
    previousPageBtnLabel() {
      return this.$i18n.t(`common.previousPageBtn.${this.labelCode}`);
    },
  },
  methods: {
    // goToPreviousPage() {
    //   this.$router.go(-1);
    //   // if (!this.colneLink.name) {
    //   //   this.$router.go(-1);
    //   // } else {
    //   //   this.$router.push(this.colneLink);
    //   // }
    // },
    goToPreviousPage() {
    // Check if there's previous history
    if (window.history.length > 2) {
      // User came via navigation, go back
      this.$router.go(-1);
    } else {
      // User came directly via URL, redirect to products
      this.$router.push('/products');
    }
  }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.my-account-btn {
  padding-left: 0 !important;
}
.el-button--text {
  color: $pastille-amber;
  cursor: pointer;
}
.previousBtn {
  color: $color-primary;
  cursor: pointer;
}
.el-button:hover {
  text-decoration: underline;
}
</style>
